// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import {Message} from 'element-ui'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';


import VuevideoPlayer from 'vue-video-player';
import 'video.js/dist/video-js.css';
import 'videojs-contrib-hls'
Vue.use(VuevideoPlayer);
Vue.use(ElementUI, { size: 'small', zIndex: 3000 });
Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
    let that = this;
  if (to.matched.some(m => m.meta.requireAuth)) {
	  
    if(sessionStorage.getItem('user')&&sessionStorage.getItem('user')!="null"&&sessionStorage.getItem('user')!=null){
      store.state.hasLogin = true
    }		
    // 对路由进行验证
    if (store.state.hasLogin) { // 已经登陆
			document.documentElement.scrollTop = 0
      if(to.name!='login'){
        if (to.meta.title) {
          document.title = to.meta.title
        }
        next() // 正常跳转到你设置好的页面
      }else{
        document.title = '首页'
        next({ path: '/' })
      }
    } else {
      //未登录则跳转到登陆界面

      // Message({
      //   message: '您还未登录请先去登录',
      //   type: 'error',
      //   duration: 5 * 100
      // })
	  setTimeout(res=>{
		  next({ path: '/login' })
	  },1000)
    }
  } else {
	
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
      document.title = to.meta.title
    }
    document.documentElement.scrollTop = 0
    next()
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  data: function(){
      return {
          tipNum: 0,
      }
  },
  components: { App },
  template: '<App/>',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js